import { useEffect, useState } from 'react';

export default function AboutHero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  return (
    <section className="relative w-full h-[70vh] min-h-[500px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=elegant%20luxury%20perfume%20distribution%20warehouse%20interior%20warm%20golden%20light%20shelves%20with%20glass%20bottles%20essential%20oils%20supplies%20minimalist%20modern%20logistics%20workspace%20soft%20ambient%20lighting&width=1400&height=700&seq=about-hero-v2&orientation=landscape)',
        }}
      />
      <div className="absolute inset-0 bg-black/50" />
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6">
        <div className={`transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-6">
            Nosotros
          </h1>
          <div className="w-16 h-px bg-white/40 mx-auto" />
        </div>
      </div>
    </section>
  );
}